import {
  useSnackbarOptionContext
} from "./chunk-IALB6UR4.mjs";
import {
  createSnackbarFn
} from "./chunk-DWJYOFCM.mjs";

// src/use-snackbar.tsx
import * as React from "react";
import { useTheme } from "@mui/material/styles";
function useSnackbar(options) {
  const theme = useTheme();
  const defaultOptions = useSnackbarOptionContext();
  return React.useMemo(() => {
    return createSnackbarFn(theme.direction, {
      ...defaultOptions,
      ...options
    });
  }, [options, theme.direction, defaultOptions]);
}

export {
  useSnackbar
};
